import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "./assets/style.css";
import { auth, db } from "./firebase";
import firebase from "firebase/compat/app";

const Chapter1_1 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question: "Frage 1: Womit könnte man Cybersecurity übersetzen?",
      options: [
        { value: "A", label: "Informationssicherheit." },
        { value: "B", label: "Kybernetischer Angriff." },
      ],
      correct: "A",
    },
    {
      question: "Frage 2: Was versteht man unter Security Awareness?",
      options: [
        {
          value: "A",
          label:
            "Menschen für IT-Sicherheit und Cybersecurity zu sensibilisieren.",
        },
        { value: "B", label: "Den Aufbau einer extra hohen Firewall." },
      ],
      correct: "A",
    },
  ];

   useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 1_1.js:", userId);
  }, [userId]);

  const handleLogout = () => {
   
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "1_1",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("1_1"),
            });
          console.log("Dokument aktualisiert mit Kapitel 1_1.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "1_1",
              completedChapters: ["1_1"],
            });
          console.log("Dokument erstellt mit Kapitel 1_1.");
        }

        navigate("/1_2");
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };

  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  Was ist Cybersecurity?
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Einleitung
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">Kapitel 1: Was ist Cybersecurity?</h3>

          <img
            src="/images/fischen.webp"
            alt="Transparent"
            style={{ position: "relative", maxWidth: "80%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center" style={{ backgroundColor: "#ffffff" }}>
          <h2 className="p-5">
            Cybersecurity – Eine der größten Herausforderungen der Zukunft
          </h2>
          <p
            className="col-lg-9 mx-auto d-inline-flex p-5 mt-5 text-decoration-none border-beispiel rounded-2"
            style={{ backgroundColor: "#f4f5f6" }}
          >
            <img
              src="/images/hacker-uni-duisburg.jpg"
              alt="Angriff"
              style={{
                position: "relative",
                maxWidth: "35%",
                height: "100%",
                margin: "20px",
              }}
            />
            Im November 2022 wurde die Universität Duisburg-Essen Opfer eines
            massiven Cyberangriffs, der ihre gesamte IT-Infrastruktur lahmlegte.
            Hacker verschlüsselten wichtige Systeme wie Lernplattformen, die
            Universitäts-Website und Prüfungssysteme und forderten Lösegeld für
            die Entschlüsselung. Selbst drei Monate nach dem Angriff waren die
            Folgen noch spürbar: Viele Systeme waren noch nicht vollständig
            wiederhergestellt und Studierende sowie die Studienverwaltung hatten
            immer noch Schwierigkeiten bei online-Aktivitäten.
          </p>
          <p className="pt-5"> Im Februar 2025 sind bei einem Cyberangriff auf die iranische Bank Sepah mehrere Terabyte sensibler Bankdaten von über 42 Millionen Kunden gestohlen worden. Darunter Kontonummern, Passwörter und Transaktionsdaten um Lösegeld in Bitcoin zu erpressen. Der Fall gilt als eines der größeren Cybersecurity-Ereignisse im Finanzsektor 2025 und wird oft in Analysen zu Angriffsstrategien und Risikomanagement im Bankwesen genannt.</p>
        </div>

        <div className="pb-5 text-center">
          <p className="col-lg-11 mx-auto">
            Cyberangriffe können schwerwiegende Folgen haben, wie beide Beispiele
            eindrucksvoll gezeigt hat. Angreifer können sensible Daten stehlen, Systeme
            lahmlegen und erhebliche finanzielle Schäden verursachen. Darüber
            hinaus können solche Angriffe auch das Vertrauen der Öffentlichkeit
            in digitale Systeme und die Institutionen, die sie nutzen,
            untergraben. Cybersecurity betrifft inzwischen jeden Aspekt unseres
            digitalen Lebens. Vom Schutz persönlicher Daten auf deinem
            Smartphone bis hin zur Sicherung nationaler und internationaler
            Infrastrukturen: Cybersecurity spielt immer eine zentrale Rolle.
          </p>
          
          <h3 className="p-5">Was ist Cybersecurity?</h3>
          <p className="col-lg-11 mx-auto">
            {" "}
            Cybersecurity dient dazu,{" "}
            <strong>
              {" "}
              Computersysteme, Netzwerke und Daten vor unbefugtem Zugriff oder
              Angriffen zu schützen.
            </strong>{" "}
            Diese Angriffe können darauf abzielen,{" "}
            <span
              data-tooltip-id="tooltip-sensible"
              data-tooltip-content="Sensible Informationen sind besonders schützenswerte Daten wie persönliche Informationen, Unternehmensgeheimnisse oder sicherheitsrelevante staatliche Daten, deren Offenlegung oder Manipulation schwerwiegende Folgen haben könnte. Sie erfordern daher besondere Schutzmaßnahmen, um ihre Vertraulichkeit und Sicherheit zu gewährleisten."
              className="custom-tooltip-trigger"
            >
              sensible Informationen{" "}
            </span>{" "}
            zu stehlen, zu verändern oder zu zerstören, Betriebsabläufe zu
            stören oder Erpressungsgelder zu fordern und vieles mehr.
            Cybersecurity ist daher nicht nur ein technisches Problem, sondern
            eine gesellschaftliche Aufgabe von großer Bedeutung.
          </p>
          <ReactTooltip
            id="tooltip-sensible"
            place="top"
            className="custom-tooltip"
          />

          <h3 className="p-5">Die Auswirkungen von Cyberangriffen</h3>
          <p className="col-lg-11 mx-auto">
            Ein Cyberangriff kann verheerende Folgen haben – sowohl auf
            persönlicher als auch auf gesellschaftlicher Ebene. Für dich
            persönlich kann ein Angriff z. B. Identitätsdiebstahl oder
            Erpressung nach sich ziehen. Ein Angriff kann aber auch
            <strong> kritische Infrastrukturen </strong> wie Kraftwerke,
            Krankenhäuser und Finanzdienstleister und damit sogar die Sicherheit
            eines Landes gefährden.
            <br /> <br />
            Cyberangriffe sind weit mehr als technische Pannen. Sie sind
            gezielte, oft hochentwickelte Angriffe, die den Betrieb von
            Unternehmen lahmlegen, immense Schäden verursachen und in manchen
            Fällen sogar Unternehmen komplett zerstören können. <br />
          </p>

          <p className="col-ld-8 mx-auto d-inline-flex p-5 m-5 text-start text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />

            <ul>
              <li>
                Der jährliche Schaden durch Angriffe auf Unternehmen in Deutschland lag 2025 bei und 289 Mrd. Euro. Cyberangriffe machen davon rund 202 Mrd. Euro aus. {" "}
                <small>Bitkom Wirtschaftsschutz 2025</small>
              </li>
              <li>
                Die Hälfte der britischen Unternehmen hat in den letzten 12
                Monaten einen Cyber-Vorfall oder eine Datenschutzverletzung
                gemeldet. <small>Britisch Government 2024</small>
              </li>
              <li>
                {" "}
                90 % der kleinen und mittleren Unternehmen (KMU), die einen
                schweren Vorfall erlebten, gaben an, dass der Cyberangriff sie
                mehr gekostet hat, als sie dachten. <small>Cowbell 2023</small>
              </li>
              <li>
                Durchschnittlich rund 24.000 infizierte Apps werden täglich im
                Internet blockiert. <small>techjury 2024</small>
              </li>
              <li>
                Die Cybersecurity-Branche wird ihren Umsatz bis 2030 etwa
                verzehnfachen kann. 2023 erzielte der Sektor 166 Milliarden
                Dollar. 2030 wären das 1,6 Billionen Dollar.{" "}
                <small>McKinsey</small>
              </li>
            </ul>
          </p>

          <p className="col-lg-11 mx-auto">
            Diese alarmierenden Zahlen zeigen, dass wir vor einer
            wirtschaftlichen Herausforderung von gigantischem Ausmaß stehen. Sie
            verdeutlichen wie entscheidend Cybersecurity für die Stabilität
            unserer globalen Wirtschaft geworden ist.{" "}
          </p>
        </div>

        <div className="grey-section">
          <div className="container p-5">
            <h3 className="p-5">Die Komplexität der Cybersecurity</h3>
            <p className="col-lg-11 mx-auto">
              Die Implementierung effektiver Cybersecuritymaßnahmen ist heute
              komplizierter denn je. Es gibt mehr vernetzte Geräte als Menschen
              und dabei werden die Angreifer immer raffinierter. Unternehmen
              jeder Größe nutzen Cloud Computing, ermöglichen{" "}
              <span
                data-tooltip-id="tooltip-remotearbeit"
                data-tooltip-content="Remote-Arbeit bezeichnet eine flexible Arbeitsform, bei der Mitarbeitende ihre Aufgaben außerhalb eines traditionellen Büros, meist von zu Hause oder einem anderen Ort, mithilfe digitaler Technologien erledigen. Sie ermöglicht ortsunabhängiges Arbeiten und fördert oft eine bessere Work-Life-Balance."
                className="custom-tooltip-trigger"
              >
                {" "}
                Remote-Arbeit{" "}
              </span>{" "}
              und integrieren das{" "}
              <span
                data-tooltip-id="tooltip-iot"
                data-tooltip-content="Das Internet of Things (IoT) ist ein Netzwerk aus Geräten wie Haushaltsgeräten, Autos oder Sensoren, die über das Internet miteinander verbunden sind und Daten austauschen, um unser Leben einfacher und vernetzter zu machen."
                className="custom-tooltip-trigger"
              >
                {" "}
                Internet der Dinge (IoT){" "}
              </span>{" "}
              in ihre Betriebsabläufe. Diese Technologien bieten enorme
              Vorteile, vergrößern aber ebenfalls die Angriffsfläche für
              Cyberkriminelle. <br />
              <br />
              Sicherheitsteams weltweit arbeiten intensiv daran, umfassende
              Strategien zu entwickeln, die auf fortschrittlichen Analysen,
              künstlicher Intelligenz und Automatisierung basieren, um
              Bedrohungen effizienter zu bekämpfen und die Auswirkungen von
              Angriffen zu minimieren. <br />
              <br />
              Auf nationaler und internationaler Ebene wurden in letzter Zeit
              immer mehr <strong> Regularien, </strong> wie z. B. 2022{" "}
              <span
                data-tooltip-id="tooltip-nis"
                data-tooltip-content="NIS2 ist eine europäische Richtlinie zur Verbesserung der Cybersecurity in wichtigen Bereichen wie Energie, Gesundheit und Finanzen. Sie legt strengere Sicherheitsanforderungen fest und verpflichtet Unternehmen in diesen Bereichen, ihre Systeme besser vor Cyberangriffen zu schützen und Sicherheitsvorfälle zu melden."
                className="custom-tooltip-trigger"
              >
                {" "}
                NIS2,{" "}
              </span>
              verabschiedet, um Mindeststandards für die Cybersecurity zu
              erreichen. Für die erfolgreiche Umsetzung und Einhaltung dieser
              Maßnahmen muss aber ein grundlegendes Verständnis für
              Cybersecurity vorhanden sein.
            </p>
            <ReactTooltip
              id="tooltip-iot"
              place="top"
              className="custom-tooltip"
            />{" "}
            <ReactTooltip
              id="tooltip-nis"
              place="top"
              className="custom-tooltip"
            />
            <ReactTooltip
              id="tooltip-remotearbeit"
              place="top"
              className="custom-tooltip"
            />
            <p className="col-lg-11 mx-auto">
              Cybersecurity ist ein nie endender Kampf gegen unsichtbare Feinde.
              Die Zukunft wird - auch durch den rasanten
              <strong> Fortschritt durch KI </strong> - von noch komplexeren
              Bedrohungen geprägt sein. Umgekehrt wird sie von revolutionären
              Verteidigungstechnologien profitieren, die darauf abzielen, die
              nächste Generation von Cyberangriffen zu verhindern. Die Frage ist
              nicht, ob wir angegriffen werden, sondern wie wir darauf
              vorbereitet sind. In diesem fortwährenden Wettlauf bleibt eines
              sicher: Die digitale Sicherheit wird immer wichtiger werden, je
              weiter sich unsere Welt vernetzt und technisiert.
              <br />
              <br />
              Durch die Auseinandersetzung mit diesem Thema erhältst du das
              Wissen und die Werkzeuge, um dich selbst, dein Umfeld und deine
              Organisation vor den zunehmend raffinierteren Cyberangriffen zu
              schützen. So entwickelst du eine Sensibilität für die drohenden
              Gefahren - eine <strong> Security Awareness. </strong> Diese
              bietet den besten Schutz, um den ständig wachsenden und sich
              wandelnden Bedrohungen effektiv zu entgegen treten zu können.
            </p>
          </div>
        </div>

        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-6">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Ende Fragenteil */}
      
      </div>
    </div>
  );
};

export default Chapter1_1;
